import { SecurableMask } from './SecurableMask'

export class JwtUser {
  public Username?: string
  public Firstname?: string
  public Lastname?: string
  public Roles?: string[]
  public EfectivePermissions?: SecurableMask[]
  public Environment?: string
  constructor(
    Username?: string,
    Roles?: string[],
    EfectivePermissions?: SecurableMask[],
    Firstname?: string,
    Lastname?: string,
    Environment?: string
  ) {
    this.Username = Username
    this.Roles = Roles
    this.EfectivePermissions = EfectivePermissions
    this.Firstname = Firstname
    this.Lastname = Lastname
    this.Environment = Environment
  }
  get Email(): string {
    if (this.Username) {
      if (this.Username.indexOf('@') !== -1) {
        return this.Username
      } else {
        return `${this.Username}@pbcgov.org`
      }
    } else {
      return ''
    }
  }
}
